// extracted by mini-css-extract-plugin
export default {"root":"dob_root__Gs04J","label":"dob_label__q5r-0","icon":"dob_icon__G6IBk","datepicker":"dob_datepicker__4zrOZ","error_text":"dob_error_text__fDKC9"};